import { useEffect } from 'react';
import { bool, func } from 'prop-types';
import Modal from '../../shared/Modal';
import Button from '../../shared/Button';
import { Box, Flex, Stack } from '../../shared/layouts';
import ShieldIcon from 'imagesUwKluis/svg/shieldfill.svg';
import ExternalLink from '../../shared/ExternalLink';
import axios from 'axios';
import {useTranslation} from "react-i18next";

const TwoFactorAuthModal = ({ isOpen, onRequestClose, onBtnClick }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (isOpen) {
      axios
        .get('/user/settings/multifactor/otp/setup')
        .catch((err) => console.log(err));
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      minWidth="600px"
      showProgressBar
      progressBarValue={1}
      progressBarTotal={6}
    >
      <Stack space="m" alignItems="center">
        <ShieldIcon
          width="130px"
          height="130px"
          css={(theme) => ({
            fill: theme?.colors?.primary || 'blue',
            display: 'block',
            margin: '40px 0 24px',
          })}
        />
        <Box fontScale="xl" fontWeight="bold">
          {t('Beveilig jouw account')}
        </Box>
        <Box textAlign="center" paddingBottom="5xl">
          {t('Beveilig je account goed. Download de Google Authenticator via') + ' '}
          <ExternalLink
            href="https://play.google.com"
            css={{ whiteSpace: 'nowrap' }}
          >
            Google Play
          </ExternalLink>{' '}
          {t('of') + ' '}
          <ExternalLink
            href="https://www.apple.com/nl/ios/app-store"
            css={{ whiteSpace: 'nowrap' }}
          >
            App Store
          </ExternalLink>
          . {t('Of een andere authenticatie-app, als je daaraan gewend bent.')}
        </Box>
      </Stack>
      <Flex justifyContent="flex-end">
        <Button onClick={onBtnClick}>{t('Verder')}</Button>
      </Flex>
    </Modal>
  );
};

TwoFactorAuthModal.propTypes = {
  isOpen: bool,
  onRequestClose: func,
  onBtnClick: func,
};

TwoFactorAuthModal.defaultProps = {
  isOpen: false,
  onRequestClose: () => {},
  onBtnClick: () => {},
};

export default TwoFactorAuthModal;
